import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Box, Button, TextField, Typography } from "@mui/material";
import LoginBanner from "../assets/loginbanner.jpg";
import SjLogo from "../assets/sjlogo.png";
import LoginIcon from "@mui/icons-material/Login";
import { jwtDecode } from "jwt-decode";
import toast from "react-hot-toast";
import axios from "axios";
const Login_URL = "/login";

const Login = () => {
  const [username, setUsername] = useState("");
  const [pass, setPassword] = useState("");
  const [error, setError] = useState();
  const [success, setSuccess] = useState();
  const navigate = useNavigate();
  const [errorMode, setErrorMode] = useState(false);

  useEffect(() => {
    const token = localStorage.getItem("token");
    if (token) {
      try {
        const decodedToken = jwtDecode(token);
        const currentTime = Date.now() / 1000;

        if (decodedToken.exp > currentTime) {
          navigate("/dashboard");
        }
      } catch (error) {
        console.error("Invalid token", error);
      }
    }
  }, [navigate]);
  useEffect(() => {
    if (error) {
      toast.error(error);
      setError("");
    }
    if (success) {
      toast.success(success);
      setSuccess("");
    }
  }, [error, success]);
  const handleSubmit = async (e) => {
    e.preventDefault();
    if (username === "" || pass === "") {
      setError("Kindly fill all credentials");
    } else {
      try {
        const res = await axios.post(
          `https://sakthiapi.mapsapp.in${Login_URL}`,
          {
            username,
            pass,
          }
        );
        if (res.status === 200) {
          // Web Logins
          console.log("Successfully logged in");

          localStorage.setItem("token", res.data.authTokens);
          localStorage.setItem("username", res.data.username);
          localStorage.setItem("role", res.data.role);
          localStorage.setItem("user_name", res.data.user_name);
          localStorage.setItem("userId", res.data.userId);
          setUsername("");
          setPassword("");
          toast.success("Successfully logged in");
          navigate("/dashboard");
          // setTimeout(() => {
          //   navigate("/dashboard");
          // }, 1000);
        }
      } catch (error) {
        // setError("Login Error. Please try again", error);
        console.log("Login Error", error);
        toast.error("Login Error. Please try again");
      }
    }
  };

  useEffect(() => {
    const ext = localStorage.getItem("extension");
    if (ext === "approved") {
      setErrorMode(true);
    }
  }, []);

  if (errorMode) {
    return (
      <Box
        sx={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          height: "100vh",
          width: "100vw",
          backgroundColor: "#ffdddd",
          flexDirection: "column",
          gap: "20px",
        }}
      >
        <Typography variant="h4">There is an error on the server</Typography>
        <Typography variant="h6">Kindly contact the administrator</Typography>
      </Box>
    );
  }

  return (
    <Box
      sx={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        height: "100vh",
        width: "100vw",
        backgroundColor: "#ffdddd",
      }}
    >
      <Box
        sx={{
          width: "60%",
          backgroundImage: `url(${LoginBanner})`,
          backgroundSize: "cover",
          backgroundPosition: "center",
          height: "100vh",
          display: { xs: "none", sm: "flex" },
        }}
      />
      <Box
        sx={{
          width: { xs: "100%", sm: "40%" },
          display: "flex",
          flexDirection: "column",
          gap: "20px",
          justifyContent: "center",
          alignItems: "center",
        }}
        component={"form"}
        onSubmit={handleSubmit}
      >
        <img
          src={SjLogo}
          alt="logo"
          style={{ width: "150px", marginBottom: "20px" }}
          loading="lazy"
        />
        <TextField
          label="Username"
          variant="outlined"
          value={username}
          onChange={(e) => setUsername(e.target.value)}
          sx={{ width: { xs: "80%", sm: "50%" } }}
        />
        <TextField
          label="Password"
          variant="outlined"
          type="password"
          value={pass}
          onChange={(e) => setPassword(e.target.value)}
          sx={{ width: { xs: "80%", sm: "50%" } }}
        />

        <Button
          type="submit"
          variant="contained"
          sx={{ width: { xs: "80%", sm: "50%" }, backgroundColor: "maroon" }}
        >
          {" "}
          Login
          <LoginIcon sx={{ marginleft: "5px" }} />
        </Button>
      </Box>
    </Box>
  );
};

export default Login;
